import { render, staticRenderFns } from "./CatalogPreviewModal.vue?vue&type=template&id=2bcf5901&scoped=true&"
import script from "./CatalogPreviewModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./CatalogPreviewModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CatalogPreviewModal.vue?vue&type=style&index=0&id=2bcf5901&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcf5901",
  null
  
)

export default component.exports